import { useMemo } from 'react'
import { RouterProvider } from 'react-router'
import { ApolloProvider } from '@apollo/client/react'
import { useAuthentication } from '@heidelbergmaterials/fcl-authclient'
import { createApolloClient } from '../api/apollo-client'
import { authenticatedRouter } from '../routes/authenticatedRoutes'

export function ShellAuthenticated() {
  const { authFlow } = useAuthentication();
  const client = useMemo(() => createApolloClient(authFlow), [authFlow]);

  return (
    <ApolloProvider client={client}>
      <RouterProvider router={authenticatedRouter} />
    </ApolloProvider>
  );
}
